import lazyScreen from '../utils/lazyScreen';
const ARRentalVehicleBooking = lazyScreen(() => import('../pages/rental/ARRentalVehicleBooking/index.js'), 'pages/rental/ARRentalVehicleBooking/index.js');
const ARRentalVehicleBookings = lazyScreen(() => import('../pages/rental/ARRentalVehicleBookings/index.js'), 'pages/rental/ARRentalVehicleBookings/index.js');
const ARRentalRoomBooking = lazyScreen(() => import('../pages/rental/ARRentalRoomBooking/index.js'), 'pages/rental/ARRentalRoomBooking/index.js');
const ARRentalRoomBookings = lazyScreen(() => import('../pages/rental/ARRentalRoomBookings/index.js'), 'pages/rental/ARRentalRoomBookings/index.js');
const ARRentalBookings = lazyScreen(() => import('../pages/rental/ARRentalBookings/index.js'), 'pages/rental/ARRentalBookings/index.js');
const ARRentalFieldBookings = lazyScreen(() => import('../pages/rental/ARRentalFieldBookings/index.js'), 'pages/rental/ARRentalFieldBookings/index.js');
const ARRentalFieldBooking = lazyScreen(() => import('../pages/rental/ARRentalFieldBooking/index.js'), 'pages/rental/ARRentalFieldBooking/index.js');
const ARRentalStatuses = lazyScreen(() => import('../pages/rental/ARRentalStatuses/index.js'), 'pages/rental/ARRentalStatuses/index.js');
const ARBookings = lazyScreen(() => import('../pages/rental/ARBookings/index.js'), 'pages/rental/ARBookings/index.js');
const ARBooking = lazyScreen(() => import('../pages/rental/ARBooking/index.js'), 'pages/rental/ARBooking/index.js');

export default [
    // ─── New unified routes ─────────────────────────────
    {
        path: '/rental/ARBookings',
        component: ARBookings
    },
    {
        path: '/rental/ARBooking/:type/:code',
        component: ARBooking
    },
    // ─── Legacy routes (kept for backward compat) ───────
    {
        path: '/rental/ARRentalBookings',
        component: ARRentalBookings
    },
    {
        path: '/rental/ARRentalVehicleBookings',
        component: ARRentalVehicleBookings
    },
    {
        path: '/rental/ARRentalRoomBookings',
        component: ARRentalRoomBookings
    },
    {
        path: '/rental/ARRentalFieldBookings',
        component: ARRentalFieldBookings
    },
    {
        path: '/rental/ARRentalFieldBooking/:code',
        component: ARRentalFieldBooking
    },
    {
        path: '/rental/ARRentalVehicleBooking/:code',
        component: ARRentalVehicleBooking
    },
    {
        path: '/rental/ARRentalRoomBooking/:code',
        component: ARRentalRoomBooking
    },
    {
        path: '/rental/ARRentalStatuses',
        component: ARRentalStatuses
    }
];
